<template>
  <aside class="widget currentContent">
    <div v-if="errorText === ''">
      <h4>VE Awards 2018</h4>
      <div class="px-2 homepage">
        <router-link class="text-primary" :to="link">
          <img class="d-block w-100 mb-2" :src="featuredIMG" alt="VE Awards 2018">
        </router-link>
        <p v-html="content"></p>
        <router-link class="text-primary" :to="link"><strong>Get involved »</strong></router-link>
      </div>
    </div>
    <div v-if="errorText !== ''" class="alert alert-warning" role="alert">
      {{errorText}}
    </div>
  </aside>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
export default {
  porps: [
    'postId'
  ],
  data () {
    return {
      content: '',
      featuredIMG: '',
      link: '',
      errorText: ''
    }
  },
  created () {
    WordpressRestAPI.getViewContent('nomination_event/42?_embed')
      .then(response => {
        this.content = response.data.excerpt.rendered
        this.link = '/ve-awards/ve-award/' + response.data.slug
        this.featuredIMG = response.data._embedded['wp:featuredmedia'][0].media_details.sizes.medium.source_url
      })
      .catch(e => {
        console.error(e)
        this.errorText = 'Unable to load latest VE Award'
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CurrentVEAward.vue